import "./quote-form.css";
import { FaCaretDown } from "react-icons/fa6";
import { BsFillGeoAltFill } from "react-icons/bs";
import { HiOutlineSwitchVertical } from "react-icons/hi";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function QuoteForm({ register, setValue }) {
  const servicesRaw = JSON.parse(localStorage.getItem("services")) || [];
  const stations = JSON.parse(localStorage.getItem("stations")) || [];
  const normalizeService = (item) => {
    if (typeof item === "string") {
      return { name: item };
    }
    if (item && typeof item === "object" && item.name) {
      return item;
    }
    return null;
  };
  const services = Array.isArray(servicesRaw)
    ? servicesRaw.map(normalizeService).filter(Boolean)
    : [];
  const [tHome] = useTranslation("homePage");
  const formRef = useRef(null);

  let currentLng = "es";
  localStorage.getItem("lng")
    ? (currentLng = localStorage.getItem("lng"))
    : (currentLng = "es");

  const [optionsView, setOptionsView] = useState("");
  const [isSwapping, setIsSwapping] = useState(false);
  const [origin, setOrigin] = useState("");
  const [destino, setDestino] = useState("");
  const [service, setService] = useState("");
  const [depText, setDepText] = useState(`${tHome("quote-shipping-form.select-dep-opt")}`);
  const [arrText, setArrText] = useState(`${tHome("quote-shipping-form.select-arr-opt")}`);
  const [serviceText, setServiceText] = useState(`${tHome("quote-shipping-form.select-service-opt")}`);

  const listServices =
    destino === "PBC" ||
    origin === "PBC" ||
    destino === "MEX2" ||
    origin === "MEX2"
      ? services.filter(
          (item) =>
            item.name !== "Animales Vivos" && item.name !== "Live Animals"
        )
      : services;

  const listCities =
    service === "Pharma XPS"
      ? stations.filter((city) => city.thumb !== "PBC")
      : stations;

  const toggleOptions = (field) => {
    setOptionsView((current) => (current === field ? "" : field));
  };

  const closeOptions = () => setOptionsView("");

  useEffect(() => {
    if (!optionsView) return undefined;

    const handleClickOutside = (event) => {
      if (formRef.current && !formRef.current.contains(event.target)) {
        closeOptions();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeOptions();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [optionsView]);

  const handleDeparture = (data) => {
    closeOptions();
    setDepText(`${data.name} - ${data.code_text.substring(0, 3)}`);
    setValue("departure", data.code_text);
    setOrigin(data.code_text);
  };

  const handleArrival = (data) => {
    closeOptions();
    setArrText(`${data.name} - ${data.code_text.substring(0, 3)}`);
    setValue("arrival", data.code_text);
    setDestino(data.code_text);
  };

  const handleService = (data) => {
    closeOptions();
    setValue("service", data.name);
    setService(data.name);
    setServiceText(data.name);
  };

  const changeValues = () => {
    if (depText === "Selecciona un Origen") return;
    if (arrText === "Selecciona un Destino") return;
    closeOptions();
    setIsSwapping(true);
    setDepText(arrText);
    setArrText(depText);
    setValue("departure", destino);
    setValue("arrival", origin);
    setOrigin(destino);
    setDestino(origin);
    window.setTimeout(() => setIsSwapping(false), 420);
  };

  return (
    <div
      className={`quote-form-home ${optionsView ? "has-open-dropdown" : ""} ${optionsView === "service" ? "has-service-open" : ""}`}
      ref={formRef}
    >
      <div className={`arr-dep-content inpt1 ${optionsView === "departure" ? "is-open" : ""}`}>
        <button
          type="button"
          className="quote-field-trigger"
          onClick={() => toggleOptions("departure")}
          aria-expanded={optionsView === "departure"}
          aria-haspopup="listbox"
        >
          <div className="information">
            <div className="icon">
              <BsFillGeoAltFill />
            </div>

            <div className="input-text">
              <label>
                <p>{tHome("quote-shipping-form.origin-label")}</p>
              </label>
              <input
                id="departure"
                type="text"
                value={depText}
                readOnly
                tabIndex={-1}
                {...register("departure", { required: true })}
              />
            </div>
          </div>

          <span className="arrow" aria-hidden="true">
            <FaCaretDown />
          </span>
        </button>

        <div
          className={`options-content ${optionsView === "departure" ? "is-open" : ""}`}
          role="listbox"
          aria-label={tHome("quote-shipping-form.origin-label")}
        >
          {listCities
            .filter((city) => city.lng === currentLng)
            .map((city, index) => (
              <button
                key={index}
                type="button"
                role="option"
                className="option-home"
                onClick={() => handleDeparture(city)}
              >
                {city.name} ({city.code_text.substring(0, 3)})
              </button>
            ))}
        </div>
      </div>

      <button
        type="button"
        className={`change-options ${isSwapping ? "is-swapping" : ""}`}
        onClick={changeValues}
        aria-label="Intercambiar origen y destino"
      >
        <HiOutlineSwitchVertical />
      </button>

      <div className={`arr-dep-content inpt2 ${optionsView === "arrival" ? "is-open" : ""}`}>
        <button
          type="button"
          className="quote-field-trigger"
          onClick={() => toggleOptions("arrival")}
          aria-expanded={optionsView === "arrival"}
          aria-haspopup="listbox"
        >
          <div className="information">
            <div className="icon">
              <BsFillGeoAltFill />
            </div>

            <div className="input-text">
              <label>
                <p>{tHome("quote-shipping-form.destination-label")}</p>
              </label>
              <input
                id="arrival"
                type="text"
                value={arrText}
                readOnly
                tabIndex={-1}
                {...register("arrival", { required: true })}
              />
            </div>
          </div>

          <span className="arrow" aria-hidden="true">
            <FaCaretDown />
          </span>
        </button>

        <div
          className={`options-content ${optionsView === "arrival" ? "is-open" : ""}`}
          role="listbox"
          aria-label={tHome("quote-shipping-form.destination-label")}
        >
          {stations
            .filter((city) => city.lng === currentLng)
            .map((city, index) => (
              <button
                key={index}
                type="button"
                role="option"
                className="option-home"
                onClick={() => handleArrival(city)}
              >
                {city.name} ({city.code_text.substring(0, 3)})
              </button>
            ))}
        </div>
      </div>

      <div className="service-type">
        <div className={`arr-dep-content inpt3 ${optionsView === "service" ? "is-open" : ""}`}>
          <button
            type="button"
            className="quote-field-trigger"
            onClick={() => toggleOptions("service")}
            aria-expanded={optionsView === "service"}
            aria-haspopup="listbox"
          >
            <div className="information">
              <div className="input-text">
                <label>
                  <p>{tHome("quote-shipping-form.type-service-label")}</p>
                </label>
                <input
                  id="service"
                  type="text"
                  value={serviceText}
                  readOnly
                  tabIndex={-1}
                  {...register("service", { required: true })}
                />
              </div>
            </div>

            <span className="arrow" aria-hidden="true">
              <FaCaretDown />
            </span>
          </button>

          <div
            className={`options-content ${optionsView === "service" ? "is-open" : ""}`}
            role="listbox"
            aria-label={tHome("quote-shipping-form.type-service-label")}
          >
            {listServices.map((item, index) => (
              <button
                key={index}
                type="button"
                role="option"
                className="option-home"
                onClick={() => handleService(item)}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuoteForm;
